import { take, filter } from 'rxjs/operators';
export function waitForNext(criteria) {
    return function (observable) {
        return observable.pipe(filter(function (value) { return valueMeetsCriteria(value, criteria); }), take(1));
    };
}
function valueMeetsCriteria(value, criteria) {
    if (!criteria)
        return !!value;
    else
        return criteria(value);
}
//# sourceMappingURL=wait-for-next.js.map